import React from "react"

import {addClass} from '../components/GlobalFunctions';

class Complete extends React.Component {

	componentDidMount() {
		var wrapper = document.getElementById('forgotFormContainer');
		addClass(wrapper, 'form-wrapper-finish');
	}

	render() {
		return (
			<div className="form-error form-error__finish">
				<p className="info">Your password has been successfully changed.</p>
				<p className="info">You can now proceed to login to your membership area.</p>
			</div>
		);
	}
}

export default Complete;


// WEBPACK FOOTER //
// ./src/forgot/Complete.js